import { React, useState, useEffect } from 'react'
import { object, func } from 'prop-types'
import BaseAutoComplete from './shared/BaseAutoComplete'
import fetchService from './FetchService'
import SmallTextField from './textfield/SmallTextfield'

export default function BaseServiceFilter({ filter, onChange = () => {} }) {
  const [items, setItems] = useState([])
  const [form, setForm] = useState({})

  const init = async () => {
    const result = await fetchService(filter)
    setItems(result)
  }

  useEffect(() => {
    init()
  }, [filter])

  return (
    <BaseAutoComplete
      list={items}
      listLabel={filter.listLabel}
      inputProps={{ label: filter.label }}
      Input={SmallTextField}
      onChange={element => {
        setForm(
          Object.assign(form, { [`${filter.id}`]: element[filter.itemValue] })
        )
        onChange(form)
      }}
    />
  )
}

BaseServiceFilter.propTypes = {
  filter: object,
  onChange: func
}
